var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.mdDataCodes),function(code){return _c('el-link',{key:code + _vm.getUid(),staticStyle:{"display":"block"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.onCodeClick(code)}}},[_vm._v(_vm._s(code))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }